import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DocumentFileItem, DocumentConditionItem, InspectionItemType, CommentItem, ConditionItemType } from '../../modules/clientModule/types';

export interface DocumentsState {
  AllPermitsWithConditions: DocumentConditionItem[];
  PermitConditions: InspectionItemType[];
  SelectedCondition: InspectionItemType;
  Comments: CommentItem[];
  ConditionName: string;
  selectedConditionItem: ConditionItemType;
  conditionsLoading: boolean;
  permitConditionsLoading: boolean;
}

const initialState: DocumentsState = {
  AllPermitsWithConditions: [],
  PermitConditions: [],
  SelectedCondition: {} as InspectionItemType,
  Comments: [],
  ConditionName: '',
  selectedConditionItem: {} as ConditionItemType,
  conditionsLoading: false,
  permitConditionsLoading: false,
};

export const conditionsSlice = createSlice({
  name: 'conditions',
  initialState,
  reducers: {
    setConditions: (state, action: PayloadAction<DocumentConditionItem[]>) => {
      state.AllPermitsWithConditions = action.payload;
      state.conditionsLoading = false;
    },
    setConditionsLoading: (state, action: PayloadAction<boolean>) => {
      state.conditionsLoading = action.payload;
    },
    setPermitConditions: (state, action: PayloadAction<InspectionItemType[]>) => {
      state.PermitConditions = action.payload;
      state.permitConditionsLoading = false;
    },
    setPermitConditionsLoading: (state, action: PayloadAction<boolean>) => {
      state.permitConditionsLoading = action.payload;
    },
    setSelectedCondition: (state, action: PayloadAction<InspectionItemType>) => {
      state.SelectedCondition = action.payload;
    },
    setConditionComments: (state, action: PayloadAction<CommentItem[]>) => {
      state.Comments = action.payload;
    },
    setConditionName: (state, action: PayloadAction<string>) => {
      state.ConditionName = action.payload;
    },
    setSelectedConditionItem: (state, action: PayloadAction<ConditionItemType>) => {
      state.selectedConditionItem = action.payload;
    },
    updatePermitConditionItem: (state, action: PayloadAction<Partial<InspectionItemType> & { id: number }>) => {
      const idx = state.PermitConditions.findIndex(p => p.id === action.payload.id);
      if (idx !== -1) {
        state.PermitConditions[idx] = {
          ...state.PermitConditions[idx],
          ...action.payload,
        };
      }
    },
    resetConditions: state => {
      state.AllPermitsWithConditions = [];
      state.PermitConditions = [];
      state.SelectedCondition = {} as InspectionItemType;
      state.Comments = [];
      state.ConditionName = '';
      state.selectedConditionItem = {} as ConditionItemType;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setConditions,
  setPermitConditions,
  resetConditions,
  setSelectedCondition,
  setConditionName,
  setConditionComments,
  setSelectedConditionItem,
  setConditionsLoading,
  setPermitConditionsLoading,
  updatePermitConditionItem,
} = conditionsSlice.actions;

export default conditionsSlice.reducer;
